<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">AR Invoice (Customer Bill) 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="print()">Print Bill</b-button>
          <b-button variant="primary mr-1" @click="exportcsv()">CSV e-Faktur</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-input-group>
          <b-input-group-prepend><span class="mt-1 mr-2">Print the following invoice number : </span></b-input-group-prepend>
          <b-input-group-append>
          <b-btn text="Button" @click="lkuArinvShow=true" size="sm" >
              <i class="fa plus-square"></i> Add Invoice
          </b-btn>
          </b-input-group-append>
      </b-input-group>

      <div class="report-wraper">
                <b-row >
                <div class="col-sm-6 col-lg-3" v-for="(inv,idx) in invoices" :key="inv.arinvKey">
                  <b-card :no-body="true">
                    <div class="p-3 clearfix">
                      <div class="h5 text-info mb-0 mt-2">{{inv.invoiceno}} <b-link @click="delInvoice(idx)" class="ml-2">  <i class="fa fa-trash"></i></b-link></div>
                        <small class="text-muted">{{inv.custinfo}}</small>
                    </div>
                  </b-card>
                </div>
                </b-row>

      </div>
    </b-card>
        <b-modal v-model="lkuArinvShow" size="lg" :hide-footer="true" title="List of AR Invoice"  :centered="true">
            <lku-arinv @click="onSelectLkuArinv" :formdata="lkuArInvData" ></lku-arinv>
        </b-modal>   
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss">
  .invoicelist{
    ul {
        -webkit-column-count: 4;
        -moz-column-count: 4;
        column-count: 4;
    }
  }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import lkuArinv from "../lookup/lkuArinvLazzy";
import arinv from "../../apis/arinv";

toastr.init();

export default {
  components: { Loading, lkuArinv },
  data() {
    return {
      invoices:[],
      lkuArinvShow:false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      lkuArInvData:{}
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "ostStatusname",
            label: "Outstand Status Name",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  methods: {
    onSelectLkuArinv(invLookup) {
      const ada =this.invoices.find(i => i.arinvKey == invLookup.selected.arinvKey);
      if (ada){
          toastr.error(`Nomor Invoice "${invLookup.selected.invoiceno}" sudah ada dalam List`)
      } else {
        this.invoices.push({
            arinvKey:invLookup.selected.arinvKey,
            invoiceno:invLookup.selected.invoiceno,
            custinfo: invLookup.selected.custinfo });
      }
      // this.model.custcode=invLookup.selected.custcode;
      // this.model.CustName=invLookup.selected.CustName;
      this.lkuArinvShow=false;
      this.lkuArInvData=invLookup;
      // for (var key in invLookup) {
      //     this.lkuArInvData[key] = invLookup[key];
      // }
    },
    delInvoice : function (index) {
        if (index > -1) {
            this.invoices.splice(index, 1);
        }
    },
    exportcsv: async function() {
      if (this.invoices.length>0) {
          this.isLoading=true;
          try {
              let arrInv = this.invoices.reduce((newArr, item) => {
                  newArr.push(item.arinvKey);
                  return newArr;
              }, []);
            toastr.info('Export to CSV ');
            const response = await arinv.printbillcsv(arrInv);
            this.isLoading=false;    
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Export!');
        }
    },    
    print: async function()
    {
      if (this.invoices.length>0) {
          this.isLoading=true;
          try {
              let arrInv = this.invoices.reduce((newArr, item) => {
                  newArr.push(item.arinvKey);
                  return newArr;
              }, []);

              this.isLoading=false;
              this.showReport=true;
              this.reportUrl= await arinv.printbills(arrInv);
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    close(){
      router.push("home");
    },    
  }
};
</script>
